// LightShot.tsx
import * as React from 'react';
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";
import Share from "yet-another-react-lightbox/plugins/share";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import { GalleryImage } from '../types/galleryImage';
import { SetOpenCallbackFunction } from '../types/callback';
import { displayErrorToast } from '../utils/toasts';
import { cookies } from '../cookies';

export function LightShot({ images, opened, setOpenLightShot }: { images: GalleryImage[] | undefined, opened: boolean, setOpenLightShot: SetOpenCallbackFunction }) {
    const fadeDelay: number = 300;
    const swipeDelay: number = 300;
    const zoomDelay: number = 300;

    if(!navigator.canShare && cookies.get('webshare.error') === undefined) {
        cookies.set('webshare.error', 'true', { maxAge: 3600 });
        displayErrorToast("Note: your current browser does not support the Web Share API");
    }

    return images === undefined ? (
        <> </>
    ) : (
        <Lightbox
            open={opened}
            close={() => setOpenLightShot(false)}
            slides={images}
            thumbnails={{
                position: "start",
            }}
            animation={{
                fade: fadeDelay,
                swipe: swipeDelay,
                zoom: zoomDelay
            }}
            plugins={[Thumbnails, Fullscreen, Zoom, Download, Share, Counter]} />
    )
}
